import React from "react";
import { AiFillStar } from "react-icons/ai";
import { CiStar } from "react-icons/ci";

const OrderStatusHistory = ({ orderData }) => {
  console.log("🚀 ~ OrderStatusHistory ~ orderData:", orderData)
  // Check if orderData is properly structured
  const items = orderData?.data?.items || []; // Safely access items
  const orderStatus = orderData?.data?.orderStatus;
  const totalPrice = orderData?.data?.totalPrice;
  const shouldShowMarketFee =
  orderData?.data?.marketPlaceFee &&
  ((orderData?.data?.orderType === "delivery" && orderData?.data.marketPlaceFee.delivery) ||
    (orderData?.data?.orderType === "pickup" && orderData?.data.marketPlaceFee.pickup));
  return (
    <div>
      {/* Order Status */}
      {/* <h2>Order Status: {orderStatus}</h2> */}

      {/* Table for displaying order items */}
      <table className="w-full text-left h-[90%]">
        <thead>
          <tr className="bg-[#AF313D] lg:h-[97.86px] sm:h-[29.72px] md:text-[19.78px] md:h-[68.4px] h-[29.72px] text-[8.59px] sm:text-[8.59px] font-baloo font-medium text-white lg:text-[28.3px] uppercase">
            <th className="px-4 py-2">Items</th>
            <th className="px-4 py-2">Qty</th>
            <th className="px-4 py-2">Price</th>
            <th className="px-4 py-2">Total Price</th>
          </tr>
        </thead>
        <tbody>
          {items.length > 0 ? (
            items?.map((item) => (
              <tr key={item._id} className="border-b border-[#ddd]">
                <td className="pl-[8px] pr-4 py-2 flex items-center gap-4">
                  <img
                    src={item.image}
                    alt={item.name}
                    className="lg:w-[107.06px] md:w-[74.84px] md:h-[71.84px] lg:h-[102.58px] sm:w-[32.52px] sm:h-[31.52px] w-[32.52px] h-[31.52px] object-cover rounded"
                  />
                  <div>
                    <p className="text-sm lg:text-[14.15px] text-[8.3px] md:text-[11.3px] sm:text-[8.3px] font-medium text-[#C97C2A]">
                      {item.category}
                    </p>
                    <p className="lg:text-[18.86px] text-[8.73px] sm:text-[8.73px] md:text-[11.3px] font-baloo font-medium lg:leading-10">
                      {item.name}
                    </p>
                 
                  </div>
                </td>

                <td className="sm:px-4 px-5 md:px-6 py-2 font-bold sm:text-[6.45px] text-[6.45px] lg:text-[21.22px] md:text-[14.83px]">
                  {item.quantity}x
                </td>

                <td className="px-4 py-2 text-[6.45px] sm:text-[6.45px] lg:text-[21.22px] md:text-[14.83px]">
                  £{item.basePrice}
                </td>

                <td className="sm:px-4 px-8 md:px-10 py-2 text-[6.45px] sm:text-[6.45px] lg:text-[21.22px] md:text-[14.83px]">
                  £{(item.basePrice * item.quantity).toFixed(2)}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="4" className="text-center py-4 text-red-500">
                No items found
              </td>
            </tr>
          )}
        </tbody>
      </table>

      {/* Total Price */}
      <div className="text-right py-4 font-bold mr-5">
  {/* Display Service Fee */}
  <p>Service Fee: £{orderData?.data?.serviceFee || 0}</p>
  {
 orderData?.data?.marketFee >0 && (
  <>
   <p>MarketPlace Fee: £{orderData?.data?.marketFee || 0}</p>
  </>
 )
  }


  {/* Conditionally Display Delivery Fee */}
  {orderData?.data?.orderType === 'delivery' && (
    <p>Delivery Fee: £{orderData?.data?.deliveryFee || 0}</p>
  )}

  {/* Calculate and Display Total */}
  <p>
    Total: £
    {totalPrice}
  </p>
</div>
    </div>
);
};

export default OrderStatusHistory;
